import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CAROUSEL_IMAGES = [
  'https://lh3.googleusercontent.com/d/1K0WixekR2SZU8cr6JbrBFtMucF3P4-vH',
  'https://lh3.googleusercontent.com/d/1DKyydGuE1gRSj48SjNTR30aFl_rwTqmy',
  'https://lh3.googleusercontent.com/d/1amT2WJVNuW1cRqgx8C3xrumqXVwPGmpt',
  'https://lh3.googleusercontent.com/d/12nvnGdbCuJZOC9ohBzW0SUtuOuJjvXFm',
];

const Home: React.FC = () => {
  const logoUrl = 'https://lh3.googleusercontent.com/d/1uWnIFNTuEkmg_eXmtQLh9bGccE6jk-iD';
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % CAROUSEL_IMAGES.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full bg-white flex items-center justify-center" style={{ position: 'fixed', inset: 0, overflow: 'hidden' }}>
      {/* Logo mask with rotating image carousel */}
      <div
        className="absolute inset-0"
        style={{
          WebkitMaskImage: `url(${logoUrl})`,
          maskImage: `url(${logoUrl})`,
          WebkitMaskSize: 'clamp(300px, 80vw, 1200px)',
          maskSize: 'clamp(300px, 80vw, 1200px)',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
        }}
      >
        {CAROUSEL_IMAGES.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
              i === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
      </div>

      {/* Enter button */}
      <div className="absolute left-0 right-0 flex justify-center" style={{ bottom: 'clamp(40px, 6vh, 60px)' }}>
        <button
          onClick={() => navigate('/bookshelf', { state: { showDoors: true } })}
          className="group flex items-center gap-3 transition-all duration-300"
        >
          <span
            className="font-sans font-light text-stone-700 group-hover:text-stone-900 border-b border-stone-300 group-hover:border-stone-700 pb-0.5 transition-all duration-300"
            style={{ fontSize: '11px', letterSpacing: '0.3em' }}
          >
            EXPERIENCE DESIGN
          </span>
          <span
            className="text-stone-400 group-hover:text-stone-700 transition-colors duration-300"
            style={{ fontSize: '12px' }}
          >
            →
          </span>
        </button>
      </div>
    </div>
  );
};

export default Home;
